import React, { InputHTMLAttributes, useId } from 'react'
import cx from 'classnames'

import { Icons } from '../../components/Icon'

import * as SC from './styled'

export type FilterCheckProps = InputHTMLAttributes<HTMLInputElement> & {
  name?: string
  className?: string
  error?: boolean
  label?: string
  type?: 'radio' | 'checkbox'
}

const FilterCheck = React.forwardRef<HTMLInputElement, FilterCheckProps>(
  (props, ref) => {
    const {
      className,
      id: propId,
      error,
      onChange,
      label,
      value,
      ...inputProps
    } = props
    const localId = useId()
    const id = propId || localId

    // const [isFocused, setFocused] = useState(false)
    // const isActive = isFocused || !!value

    return (
      <>
        <SC.Container className={cx('Input', className)} htmlFor={id}>
          <SC.Input
            ref={ref}
            {...inputProps}
            value={value}
            id={id ?? localId}
            type={inputProps.type ?? 'checkbox'}
            $isError={!!error}
            onChange={onChange}
            onFocus={(e: any) => {
              if (inputProps.readOnly) return
              inputProps?.onFocus?.(e)
              // setFocused(true)
            }}
            onBlur={(e: any) => {
              if (inputProps.readOnly) return
              inputProps?.onBlur?.(e)
              // setFocused(false)
            }}
          />
          <SC.OffIcon icon={Icons.roundCheck} aria-hidden />
          <SC.OnIcon icon={Icons.roundCheckActive} aria-hidden />
          {label && <SC.Label>{label}</SC.Label>}
        </SC.Container>
      </>
    )
  }
)

FilterCheck.displayName = 'FilterCheck'

export default FilterCheck
